export class Option {

  showMasterLabel = false;
}
